import React, { Component } from "react";
import { withRouter, Redirect } from "react-router-dom";
import classnames from "classnames";
import Loader from "../../Loader/Loader";
import Users from "./Users";
// import Statistics from "./Statistics";
import CostOfLiving from "./CostOfLiving";
import NeighbourhoodData from "./NeighbourhoodData";
import MyAccount from "./MyAccount";
import MapData from "./MapData";
import Jobs from "./Jobs";
// import CouponPage from "./CouponPage";
import Employer from "./Employer";
import Nominee from "./Nominee";
import Transit from "./Transit";

import auth from "../../auth/authHelper";
import read from "../../auth/authUser";
import styles from "./AdminPage.scss";

class AdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: undefined,
      redirectToSignin: false,
      page: undefined
    };
  }

  componentDidMount = () => {
    var id = auth.isAuthenticated().user._id;
    this.init(id);
  };

  init = userId => {
    const jwt = auth.isAuthenticated();
    read(
      {
        userId: userId
      },
      { t: jwt.token }
    ).then(data => {
      if (data.error) {
        this.setState({ redirectToSignin: true });
      } else {
        this.setState({
          user: data
        });
      }
    }).catch(err => console.log(err))
  };

  renderData(param) {
    switch (param) {
      case "myaccount":
        return <MyAccount />;
      // case "statistics":
      //   return <Statistics />;
      case "users":
        return <Users />;
      case "mapdata":
        return <MapData />;
      case "costofliving":
        return <CostOfLiving />;
      case "neighbourhooddata":
        return <NeighbourhoodData />;
      case "jobs":
        return <Jobs />;
      // case "coupons":
      //   return <CouponPage />;
      case "employer":
        return <Employer />;
      case "transit":
        return <Transit />;
      case "nominee":
        return <Nominee />
      case "analytics":
        return <Redirect to="/analytics" />
      default:
        return <MyAccount />;
    }
  }

  getStyle = page => {
    if (page === this.state.page) {
      return classnames([styles.NavChoice], [styles.SelectedChoice]);
    } else {
      return styles.NavChoice;
    }
  };

  render() {
    if (this.state.redirectToSignin) {
      return <Redirect to="/signin" />;
    }
    if (!this.state.user) {
      return <Loader />;
    }
    return (
      <div className={styles.admin}>
        <div className={styles.side}>
          {this.state.user && <h5>Welcome, {this.state.user.first_name}!</h5>}

          <div className={styles.Nav}>
            <span
              className={this.getStyle("myaccount")}
              onClick={() => {
                this.setState({ page: "myaccount" });
              }}
            >
              My Account
            </span>

            {/**
              <span
              className={this.getStyle("statistics")}
              onClick={() => {
                this.setState({
                  page: "statistics"
                });
              }}
            >
              Statistics
            </span>
            **/}

            <span
              className={this.getStyle("users")}
              onClick={() => {
                this.setState({ page: "users" });
              }}
            >
              Users
            </span>

            <span
              className={this.getStyle("mapdata")}
              onClick={() => {
                this.setState({
                  page: "mapdata"
                });
              }}
            >
              Map Data
            </span>

            <span
              className={this.getStyle("costofliving")}
              onClick={() => {
                this.setState({ page: "costofliving" });
              }}
            >
              Cost of Living Data
            </span>

            <span
              className={this.getStyle("neighbourhooddata")}
              onClick={() => {
                this.setState({ page: "neighbourhooddata" });
              }}
            >
              Neighbourhood Data
            </span>

            <span
              className={this.getStyle("jobs")}
              onClick={() => {
                this.setState({ page: "jobs" });
              }}
            >
              Job Data
            </span>
            {/**
            <span
              className={this.getStyle("coupons")}
              onClick={() => {
                this.setState({ page: "coupons" });
              }}
            >
              Coupon Data
            </span>
          **/}
            <span
              className={this.getStyle("employer")}
              onClick={() => {
                this.setState({ page: "employer" });
              }}
            >
              Employer Data
            </span>
            <span
              className={this.getStyle("nominee")}
              onClick={() => {
                this.setState({ page: "nominee" });
              }}
            >
              Nominee Data
              </span>
              <span
              className={this.getStyle("transit")}
              onClick={() => {
                this.setState({ page: "transit" });
              }}
            >
              Transit Data
            </span>
            <span
              className={this.getStyle("analytics")}
              onClick={() => {
                this.setState({ page: "analytics" });
              }}
            >
              Analytics
            </span>
          </div>

          <button
            className={classnames("btn btn-primary z-depth-0 right", styles.SignOut)}
            onClick={() => {
              auth.signout(() => {
                this.props.history.push("/admin");
              });
            }}
          >
            Sign Out
          </button>
        </div>
        <div className={styles.info}>{this.renderData(this.state.page)}</div>
      </div>
    );
  }
}
export default withRouter(AdminPage);



// WEBPACK FOOTER //
// ./src/components/pages/Admin/AdminPage.js